<template>
    <div>
        <p class="text-subtitle1">
            Select users to unassign them from the client.
        </p>
        <user-search-input v-model="keyword" filled outlined dense />
        <assigned-client-users-table
          :client-id="client.id"
          :keyword="keyword"
          v-model:selected="selected"
          class="q-mt-md"
          ref="userClients"
        />
        <div class="text-center q-mt-md">
          <async-btn
            v-show="selected.length"
            :task="task"
            label="Unassign"
            color="primary"
            @click="unassign"
          />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, UserClient, List } from '@/type';
import UserSearchInput from '@/client-user/UserSearchInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { unassignAll } from '@/client-user/client-user';
import AssignedClientUsersTable from './AssignedClientUsersTable.vue';

interface Data {
  keyword: string|null,
  selected: UserClient[],
  task: Promise<any>|null,
}

export default defineComponent({
  components: {
    UserSearchInput,
    AssignedClientUsersTable,
    AsyncBtn,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: null,
      selected: [],
      task: null,
    };
  },
  methods: {
    unassign(): void {
      this.task = unassignAll(this.selected);
      this.task.then(() => {
        const name = `${this.client.lastName}, ${this.client.firstName}`;
        const total = this.selected.length;
        notify(
          `Unassigned ${total} user${(total === 1) ? '' : 's'} from ${name}`,
        );

        this.selected.forEach((uc) => {
          (this.$refs.userClients as List).removeItem(uc);
        });
        this.selected = [];
      });
    },
  },
});
</script>
